import { defineMessages } from 'react-intl';
import applyMiddleware from '../../utils/route/applyMiddleware';
import requireLogin from '../../utils/route/requireLogin';
import logout from '../../utils/route/logout';
import ensureActivationKey from '../../utils/route/ensureActivationKey';
import SignUp from './components/SignUp';
import Login from './components/Login';
import Logout from './components/Logout';
import Forgot from './components/Forgot';
import ResetPassword from './components/ResetPassword';
import AccountMain from './components/AccountMain';
import ViewAccount from './components/ViewAccount';
import EditAccount from './components/EditAccount';

const messages = defineMessages({
  title: {
    id: 'meta.title.account',
    defaultMessage: 'My Account',
    description: 'Extra information to be added to the page title in the html head element.'
  },

  loginTitle: {
    id: 'meta.title.accountLogin',
    defaultMessage: 'Login',
    description: 'Extra information to be added to the page title in the html head element.'
  },

  signUp: {
    id: 'meta.title.signUp',
    defaultMessage: 'Sign Up',
    description: 'Extra information to be added to the page title in the html head element.'
  }
});

const account = {
  path: 'account',

  name: 'account',

  meta: {
    title: messages.title
  },

  childRoutes: [
    {
      name: 'accountProtected',

      onEnter: applyMiddleware(requireLogin),

      component: AccountMain,

      childRoutes: [
        {
          name: 'viewAccount',
          path: 'view',
          component: ViewAccount
        },
        {
          name: 'editAccount',
          path: 'edit',
          component: EditAccount
        }
      ]
    },
    {
      path: 'sign-up',
      name: 'signUp',
      component: SignUp,
      meta: {
        title: messages.signUp
      }
    },
    {
      path: 'login',
      name: 'login',
      component: Login,
      meta: {
        title: messages.loginTitle
      }
    },
    {
      path: 'logout',
      name: 'logout',
      component: Logout,
      onEnter: applyMiddleware(logout)
    },
    {
      path: 'forgot',
      name: 'forgot',
      component: Forgot
    },
    {
      path: 'reset',
      name: 'reset',
      component: ResetPassword,
      onEnter: applyMiddleware(ensureActivationKey)
    }
  ]
};

export default account;



// WEBPACK FOOTER //
// ./src/apps/Account/index.js